var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4159_4279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.578 1.07997C22.254 0.755966 21.81 0.587966 21.336 0.599966L12.984 1.25997C12.252 1.28997 11.568 1.58397 11.046 2.10597L1.44598 11.688C0.317976 12.816 0.317976 14.652 1.44598 15.774L7.88398 22.212C8.44798 22.776 9.18598 23.058 9.92998 23.058C10.674 23.058 11.412 22.776 11.976 22.212L21.576 12.63C22.098 12.108 22.398 11.418 22.422 10.704L23.064 2.29197C23.076 1.84197 22.902 1.39797 22.584 1.07997H22.578ZM21.222 10.644C21.21 11.076 21.03 11.478 20.73 11.784L11.13 21.366C10.47 22.026 9.40198 22.026 8.73598 21.366L2.29198 14.928C1.63198 14.268 1.63198 13.194 2.29198 12.54L11.898 2.95197C12.204 2.64597 12.606 2.47197 13.038 2.45997L21.402 1.79997C21.402 1.79997 21.414 1.79997 21.42 1.79997C21.54 1.79997 21.648 1.84797 21.732 1.92597C21.816 2.00397 21.864 2.12997 21.864 2.22597L21.222 10.638V10.644Z",
    fill: "#353EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35 4.04395C14.688 4.04395 13.332 5.39995 13.332 7.06195C13.332 8.72395 14.688 10.0799 16.35 10.0799C18.012 10.0799 19.368 8.72395 19.368 7.06195C19.368 5.39995 18.018 4.04395 16.35 4.04395ZM16.35 8.87995C15.348 8.87995 14.532 8.06395 14.532 7.06195C14.532 6.05995 15.348 5.24395 16.35 5.24395C17.352 5.24395 18.168 6.05995 18.168 7.06195C18.168 8.06395 17.352 8.87995 16.35 8.87995Z",
    fill: "#353EBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4159_4279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.31868c73a32e72e351ab73e385873f3d.svg";
export { ForwardRef as ReactComponent };